import { makeStyles } from '@material-ui/core';
import { ALARM_FILTERS_MENU_WIDTH } from './Filters.utils';

export const useFilterStyles = makeStyles((theme) => ({
  select: {
    height: 40,
    maxHeight: 40,
    zIndex: 200,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
    '& .select__control': {
      minWidth: 60,
    },
  },
  alarmsSelect: {
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
  multiSelect: {
    width: 300,
    minHeight: 40,
    maxHeight: 40,
    '& .select__value-container': {
      height: 36,
      overflowY: 'auto',
    },
    [theme.breakpoints.down('sm')]: {
      height: 66,
      minHeight: 66,
      maxHeight: 66,
      '& .select__value-container': {
        height: 60,
      },
    },
  },
  alarmsMultiSelect: {
    [theme.breakpoints.down(ALARM_FILTERS_MENU_WIDTH)]: {
      height: 66,
      minHeight: 66,
      maxHeight: 66,
      '& .select__value-container': {
        height: 60,
      },
    },
  },
  checkbox: {
    width: 100,
    minWidth: 100,
    [theme.breakpoints.down(ALARM_FILTERS_MENU_WIDTH)]: {
      width: 160,
      minWidth: 160,
    },
  },
}));
